/// <amd-module name="Wit/Portal/Redux/WorkItemPortalContracts" />
import { FieldValueType } from "Wit/WorkItemTypes/Contracts";

export interface IWorkItemPortalAwareState {
    workItemPortalState: IWorkItemPortalState;
}

export interface IWorkItemPortalState {
    workItemQueue: IPortalWorkItem[];
}

export const defaultWorkItemPortalState: IWorkItemPortalState = {
    workItemQueue: []
};

export interface IPortalWorkItem {
    /**
     * WorkItemId.
     * In creation mode, pass temporaryWorkItemId as workItemId */
    workItemId: number;

    /**
     * Whether to open workItem in creationMode
     * @default false
     */
    isCreationMode?: boolean;

    /**
     * Optional: needed if workItem is in creation mode
     */
    workItemTypeName?: string;

    /**
     * Optional: initial field values for creation mode
     */
    initialFieldValues?: { [fieldRefName: string]: FieldValueType };

    /**
     * OnDismiss callback
     */
    onDismiss?: () => void;
}
